import React from "react";
import Tag from "./Tag";
import Tooltip from "./Tooltip";

interface TagsProps {
  tags: string[];
  onRemove?: (index: number) => void;
  maxVisible?: number;
  noWrap?: boolean;
}

const Tags: React.FC<TagsProps> = ({ tags, onRemove, maxVisible, noWrap }) => {
  if (tags.length === 0) {
    return null;
  }

  const truncate = maxVisible !== undefined && tags.length > maxVisible;
  const visibleTags = truncate ? tags.slice(0, maxVisible) : tags;
  const hiddenTags = truncate ? tags.slice(maxVisible) : [];
  const wrapClass = noWrap ? "flex-nowrap" : "flex-wrap";

  return (
    <div className={`flex ${wrapClass} items-center gap-2`}>
      {visibleTags.map((tag, index) => (
        <Tag
          key={index}
          label={tag}
          onRemove={onRemove ? () => onRemove(index) : undefined}
        />
      ))}
      {truncate && (
        <Tooltip
          content={
            <div className="flex flex-wrap items-center gap-2">
              {hiddenTags.map((tag, index) => (
                <Tag key={index} label={tag} />
              ))}
            </div>
          }
        >
          <span
            tabIndex={0}
            onClick={(event) => event.stopPropagation()}
          >
            <Tag label={`+${hiddenTags.length}`} />
          </span>
        </Tooltip>
      )}
    </div>
  );
};

export default Tags;
